module.exports = __webpack_public_path__ + "static/media/index.60c0354b.scss";


//////////////////
// WEBPACK FOOTER
// ./src/views/policies/index.scss
// module id = 397
// module chunks = 0